import * as helper from './../../../Assets/Js/helper';

require('./../Less/CamchatFrame.less')

// You can remove this line safely!
const guest = 'Gast' + Math.floor((Math.random() * 150) + 6200);
let currentIndex = 0;
let timeout = false;
let targetURL = '';
let successURL = '';
let countdown;

helper.onDocumentLoaded(function () {
	const $data = helper.$('#content');
	const chathistory = JSON.parse(helper.getData($data, 'chathistory'));
	const playlist = parseInt(helper.getData($data, 'playlist'));
	let userLiveCounter = helper.getData($data, 'userlivecounter');
	const adtv = helper.getData($data, 'adtv');
	const host = helper.getData($data, 'host');
	const nativeVideo: HTMLVideoElement = document.getElementById('videoplayer') as HTMLVideoElement;
	const sendMessageButton: HTMLButtonElement = helper.$('#inputLine button')[0];

	helper.addClickListener(sendMessageButton, () => {
		addComment();
	})

	const ab1 = parseInt(helper.getData($data, 'ab1'));
	const baukasten = parseInt(helper.getData($data, 'baukasten'));

	if (baukasten === 1) {
		const ctas = helper.$('#cta, .cta');
		for (let i = 0; i < ctas.length; i++) {
			const cta = ctas[i];
			helper.addClickListener(cta, function (e) {
				e.preventDefault();
				window.top.postMessage('doYourFunkyThing', '*');
			});
		}
	} else if (ab1 === 1) {
		const ctas = helper.$('#cta, .cta');
		for (let i = 0; i < ctas.length; i++) {
			const cta = ctas[i];
			helper.addClickListener(cta, function (e) {
				e.preventDefault();
				window.top.postMessage({action: 'open sesame', adtv: adtv, host: host}, '*')
			});
		}
	}

	targetURL = helper.getData($data, 'targeturl');
	countdown = parseInt(helper.getData($data, 'countdown'));

	successURL = decodeURIComponent(helper.getData($data, 'successurl'));

	if (playlist === 999) {
		updateCountdown();
		blur();
	} else {
		const video = helper.$('#videoplayer');
		helper.addEventListener(video, 'contextmenug', (e) => e.preventDefault());
		helper.addEventListener(video, 'ended', () => {
			timeout = true;
			nativeVideo.pause();
		})

		const speaker = helper.$('.speaker')[0];
		helper.addClickListener(speaker, function (e) {
			e.preventDefault();
			nativeVideo.muted = !nativeVideo.muted;
			helper.toggleClass(speaker, 'mute');
		});

		addUserCount();
		removeUserCount();
		syncVideo(chathistory);
	}

	helper.addEventListener(helper.$('#inputText'), 'keyup', function (event: KeyboardEvent) {
		if (event.key === "Enter") {
			addComment();
		}
	})

	function addUserCount() {
		if (timeout === false && playlist !== 999) {
			const randomCount = (Math.floor((Math.random() * 10) + 5) * 1000);
			setTimeout(function () {
				userLiveCounter = userLiveCounter + (Math.floor((Math.random() * 5) + 1));
				helper.$('#userLiveCounter').innerText = userLiveCounter;
				addUserCount();
			}, randomCount);
		}
	}

	function removeUserCount() {
		if (timeout === false && playlist !== 999) {
			const randomCount = (Math.floor((Math.random() * 10) + 30) * 1000);
			setTimeout(function (event) {
				if (userLiveCounter > 70) {
					userLiveCounter = userLiveCounter - (Math.floor((Math.random() * 10) + 10));
				} else {
					userLiveCounter = userLiveCounter - (Math.floor((Math.random() * 5) + 1));
				}
				helper.$('#userLiveCounter').innerText = userLiveCounter;
				removeUserCount();
			}, randomCount);
		}
	}
});

function syncVideo(chathistory) {
	updateCountdown();
	if (currentIndex < chathistory.length) {
		setChatMessages(chathistory);
	}
	setTimeout(function () {
		syncVideo(chathistory);
	}, 300);
}

function setChatMessages(chathistory) {
	const video = helper.$('#videoplayer') as HTMLVideoElement;

	if (chathistory[currentIndex].time === (Math.floor(video.currentTime))) {
		const $chatContent = helper.$('#chatContent');
		let chatMessage;

		chatMessage = helper.stringToHtml('<span class="chatMessage">' + chathistory[currentIndex].message + '<span class="guestname">Gast' + chathistory[currentIndex].userid + '</span></span>');
		calculateOpacity();

		$chatContent.append(chatMessage);
		currentIndex = currentIndex + 1;
		$chatContent.scrollTop = $chatContent.scrollHeight;
	}
}

function addComment() {
	const $inputText = helper.$('#inputText') as HTMLInputElement;
	let inputText = $inputText.value;
	inputText = inputText.replace(/(<([^>]+)>)/ig, '');
	inputText = inputText.replace(/(?:\r\n|\r|\n|\s|&nbsp;)+/g, ' ');
	inputText = inputText.trim();
	if (inputText !== '') {
		const $chatContent = helper.$('#chatContent');
		let userInput;
		userInput = helper.stringToHtml('<span class="userInput">' + inputText + '<span class="guestname">Du als ' + guest + '</span></span>');
		calculateOpacity();
		$chatContent.append(userInput);
		$chatContent.scrollTop = $chatContent.scrollHeight;
	}
	$inputText.value = '';
}

function updateCountdown() {
	let runningSeconds = 0;
	const videoPlayer = helper.$('#videoplayer');

	if (videoPlayer !== null) {
		runningSeconds = videoPlayer.currentTime;
	}
	const seconds = Math.floor(runningSeconds);

	const remainingTime = countdown - seconds;

	let remainingSeconds = remainingTime % 60;
	let remainingMinutes = Math.floor((remainingTime / 60));

	if (remainingSeconds < 0) {
		remainingSeconds = 0;
	}

	if (remainingMinutes < 0) {
		remainingMinutes = 0;
	}

	let remainingSecondsText = remainingSeconds.toString();
	if (remainingSeconds < 10) {
		remainingSecondsText = '0' + remainingSeconds;
	}

	let remainingMinutesText = remainingMinutes.toString();
	if (remainingMinutes < 10) {
		remainingMinutesText = '0' + remainingMinutes;
	}

	helper.$('span.time')[0].innerText = remainingMinutesText + ':' + remainingSecondsText;

	if (remainingMinutes === 0 && remainingSeconds === 0) {
		blur();
		if (!timeout) {
			helper.triggerEvent(window, 'timeout')
		}
	}
}

function blur() {
	const container = helper.$('#container');
	const button = helper.$('#cta');
	const wrapper = helper.$('#wrapper');
	wrapper.style.display = 'flex';
	button.style.display = 'flex';
	helper.addClass(container, 'blur');
	helper.addClickListener(container, function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
	});
}

function calculateOpacity() {
	const $chatContent = helper.$('#chatContent');
	const upperbound = $chatContent.getBoundingClientRect().top;
	const boxHeight = $chatContent.height;

	const children = $chatContent.childNodes;
	for (let i = 0; i < children.length; i++) {
		const child = children[i];
		if (child.nodeType === 'span') {
			const $me = child as HTMLSpanElement;
			const opacity = 1 / boxHeight * ($me.getBoundingClientRect().top - upperbound);
			$me.style.opacity = opacity.toString();
		}
	}
}

function setChatWidth() {
	if (window.innerWidth >= 860) {
		const width = window.innerWidth;

		const videoHolder = helper.$('#video');
		const videoWith = videoHolder.getBoundingClientRect().width;
		const chatWidth = width - videoWith;
		const videoHeight = videoHolder.getBoundingClientRect().height;
		const inputFieldsHeight = helper.$('#input').getBoundingClientRect().height;
		const chatContentHeight = (videoHeight - inputFieldsHeight) - 34; //Padding from ChatArea
		helper.$('#chat').style.width = chatWidth + 'px';
		helper.$('#chatContent').style.height = chatContentHeight + 'px';
	} else {
		helper.$('#chat').style.width = '100%';
	}
}
